// Estimated real-world character lengths for each template variable.
// {{ApplicationLink}} uses the exact length of the production URL format:
//   https://dashboard.getdoublenickel.com/driver-application?applicationId=<uuid>
// UUIDs are always 36 characters, so this is a fixed value. {{ReviewLink}}
// is the same route plus "/review" when the company has no slug yet; the
// /c/<slug>/review form is shorter, so this stays the safe estimate.
export const VARIABLE_ESTIMATED_LENGTHS: Record<string, number> = {
  ApplicationLink: 107,
  ReviewLink: 114,
  CompanyName: 25,
  EmployeeFullName: 20,
  EmployeeFirstName: 10,
  EmployeePhoneNumber: 14,
  ApplicantFullName: 20,
  ApplicantFirstName: 10,
  JobListingName: 20,
}

/**
 * Returns the estimated character length of a template string after
 * variables are substituted with their expected real-world values.
 *
 * Variables are in the format {{VariableName}}.
 * Any unknown variables are counted at their placeholder length.
 */
export function getEstimatedLength(content: string): number {
  return content.replace(/\{\{(\w+)\}\}/g, (_match, variableName: string) => {
    const estimatedLength = VARIABLE_ESTIMATED_LENGTHS[variableName]
    return estimatedLength !== undefined ? 'x'.repeat(estimatedLength) : _match
  }).length
}
